import React, { useState } from 'react';

//PROPERTIES

import Select from 'react-select'

import { fixCountryName } from './formatCountry';

export const MapProperties = ({ handleInput, indicator, country, handleExportClickPDF }) => {

    let options = [
        { value: 'World', label: "World" },
        { value: 'OECD', label: 'OECD - Organization For Economic Co-operation and Development' },
        { value: 'APAC', label: 'APAC - Asia Pacific' },
        { value: 'EMEA', label: 'EMEA - Europe, Middle East and Africa' },
        { value: 'LATAM', label: 'LATAM- Latin American' },
        { value: 'NA', label: 'NA - North America' },
        { value: 'Africa', label: 'Africa' },
        { value: 'Americas', label: 'Americas' },
        { value: 'Asia', label: 'Asia' },
        { value: 'Europe', label: 'Europe' },
        { value: 'Oceania', label: 'Oceania' },
    ]


    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: '100%',
            boxSizing: 'border-box',
            border: '1px solid var(--primary-color)',
            borderRadius: '10px',
            paddingRight: '40px',
            display: 'flex',
            position: 'relative',
            overflow: 'hidden',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '100%',
            overflowY: 'auto',
            flexWrap: 'wrap',
            alignItems: 'center',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
        }),
        multiValue: (provided) => ({
            ...provided,
            margin: '2px',
        }),
    };

    return (
        <>
            <p className='orange smallText mediumFont inputTitle indicatorMapTitle'>Indicator</p>
            <select className='input indicatorMapInput' value={indicator} onChange={e => handleInput(e.target.value, 'indicator')}>
                <option value='Geothermal Gross Electrical generation GWh/yr'>Geothermal Power - total Production</option>
                <option value='Geothermal Installed Capacity (MWe)'>Geothermal Power - total Installed Capacity</option>
                <option value="Total Energy used (TJ/year)">Geothermal H&C - total Production</option>
                <option value="Total Installed Capacity (MWt)">Geothermal  H&C - total Installed Capacity</option>
                <option value="combinedGeothermalHcPowerProduction">Combined Geothermal Power and H&C - Production</option>
                <option value="combinedGeothermalHcInstalledCapacity">Combined Geothermal Power and H&C - Installed Capacity</option>
            </select >
            <p className='orange smallText mediumFont inputTitle countryMapTitle'>Region</p>
            <Select
                options={options}
                styles={customStyles}
                isMulti name="countries"
                className='countryMapInput'
                value={country}
                onChange={value => { handleInput(value, 'country') }}
                components={{ ClearIndicator: () => null }}
            />
            <p id='mapYearText' className='smallText'>Choose year with the slider</p>
            <div id='export' className='input' onClick={handleExportClickPDF}>Export Map<span>↓</span></div>
        </>
    );
}

export const ChartProperties = ({
    handleInput,
    chartType,
    indicator,
    country,
    year,
    geodata,
    yearsList,
    handleExportClickPDF
}) => {
    let options = [
        { value: 'World', label: "World" },
        { value: 'OECD', label: 'OECD - Organization For Economic Co-operation and Development' },
        { value: 'APAC', label: 'APAC - Asia Pacific' },
        { value: 'EMEA', label: 'EMEA - Europe, Middle East and Africa' },
        { value: 'LATAM', label: 'LATAM- Latin American' },
        { value: 'NA', label: 'NA - North America' },
        { value: 'Africa', label: 'Africa' },
        { value: 'Americas', label: 'Americas' },
        { value: 'Asia', label: 'Asia' },
        { value: 'Europe', label: 'Europe' },
        { value: 'Oceania', label: 'Oceania' },
    ];

    // Append additional countries from geodata.
    geodata.forEach((data) => {
        const fixedName = fixCountryName(data.id);
        options.push({ value: data.id, label: fixedName });
    });

    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: '100%',
            boxSizing: 'border-box',
            border: '1px solid var(--primary-color)',
            borderRadius: '10px',
            paddingRight: '40px',
            display: 'flex',
            position: 'relative',
            overflow: 'hidden',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '100%',
            overflowY: 'auto',
            flexWrap: 'wrap',
            alignItems: 'center',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
        }),
        multiValue: (provided) => ({
            ...provided,
            margin: '2px',
        }),
    };

    return (
        <>
            <p className='orange smallText mediumFont inputTitle typeChartInput'>Chart Type</p>
            <select
                className='input typeChartInput'
                value={chartType}
                onChange={e => handleInput(e.target.value, 'chartType')}
            >
                <option value="Bar">Bar</option>
                <option value="Pie">Pie</option>
                <option value="Pile">Pile</option>
            </select>
            <p className='orange smallText mediumFont inputTitle indicatorChartInput'>Indicator</p>
            <select
                className='input indicatorChartInput'
                value={indicator}
                onChange={e => handleInput(e.target.value, 'indicator')}
            >
                {chartType === 'Bar' && (
                    <>
                        <option value="Total Gross Electrical generation GWh/yr">Power - total Production</option>
                        <option value="Total Installed Capacity (MWe)">Power - total Installed Capacity</option>
                        <option value="Total Energy used (TJ/year)">H&C - total Production</option>
                        <option value="Total Installed Capacity (MWt)">H&C - total Installed Capacity</option>
                        <option value="Gross Energy Produced (GEP) (GWh/year)">Power by category - Production</option>
                        <option value="Installed Capacity (MW)">Power by category - Capacity</option>
                        <option value="Energy used (net) (TJ/year)">H&C by category - Production</option>
                        <option value="Nominal Capacity (MWt)">H&C by category - Capacity</option>
                    </>
                )}
                {chartType === 'Pie' && (
                    <>
                        <option value="Gross Energy Produced (GEP) (GWh/year)">Power by category - Production</option>
                        <option value="Installed Capacity (MW)">Power by category - Capacity</option>
                        <option value="Energy used (net) (TJ/year)">H&C by category - Production</option>
                        <option value="Nominal Capacity (MWt)">H&C by category - Capacity</option>
                    </>
                )}
                {chartType === 'Pile' && (
                    <>
                        <option value="Gross Energy Produced (GEP) (GWh/year)">Power by category - Production</option>
                        <option value="Installed Capacity (MW)">Power by category - Capacity</option>
                        <option value="Energy used (net) (TJ/year)">H&C by category - Production</option>
                        <option value="Nominal Capacity (MWt)">H&C by category - Capacity</option>
                    </>
                )}
            </select>
            <p className='orange smallText mediumFont inputTitle countryChartTitle'>Region / Country</p>
            <Select
                options={options}
                styles={customStyles}
                isMulti
                name="countries"
                className='countryChartInput'
                value={country}
                onChange={value => handleInput(value, 'country')}
                components={{ ClearIndicator: () => null }}
            />
            {chartType !== "Pile" && (
                <>
                    <p className='orange smallText mediumFont inputTitle yearChartInput'>WGC Year</p>
                    <select
                        className='input yearChartInput'
                        value={year}
                        onChange={e => handleInput(e.target.value, 'year')}
                    >
                        {yearsList && yearsList.map((year, index) => (
                            <option key={index} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </>
            )}
            <div id='export' className='input' onClick={handleExportClickPDF}>
                Export Chart<span>↓</span>
            </div>
        </>
    );
};

export const TableProperties = ({ handleInput, tableType, indicator, country, year, geodata, yearsList, handleExportClickPDF, handleExportClickCSV }) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };

    let options = [
        { value: 'World', label: "World" },
        { value: 'OECD', label: 'OECD - Organization For Economic Co-operation and Development' },
        { value: 'APAC', label: 'APAC - Asia Pacific' },
        { value: 'EMEA', label: 'EMEA - Europe, Middle East and Africa' },
        { value: 'LATAM', label: 'LATAM- Latin American' },
        { value: 'NA', label: 'NA - North America' },
        { value: 'Africa', label: 'Africa' },
        { value: 'Americas', label: 'Americas' },
        { value: 'Asia', label: 'Asia' },
        { value: 'Europe', label: 'Europe' },
        { value: 'Oceania', label: 'Oceania' },
    ]

    geodata.map((data) => {
        const fixedName = fixCountryName(data.id);
        options.push({ value: data.id, label: fixedName })
    });

    const customStyles = {
        control: (provided) => ({
            ...provided,
            height: '100%',
            boxSizing: 'border-box',
            border: '1px solid var(--primary-color)',
            borderRadius: '10px',
            paddingRight: '40px',
            display: 'flex',
            position: 'relative',
            overflow: 'hidden',
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '100%',
            overflowY: 'auto',
            flexWrap: 'wrap',
            alignItems: 'center',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 2,
        }),
        multiValue: (provided) => ({
            ...provided,
            margin: '2px',
        }),
    };

    return (
        <>
            <p className='orange smallText mediumFont inputTitle typeTableInput'>Table Type</p>
            <select className='input typeTableInput' value={tableType} onChange={e => handleInput(e.target.value, 'tableType')}>
                <option value="List">List</option>
                <option value="Report">Report</option>
            </select>
            <p className='orange smallText mediumFont inputTitle indicatorTableInput'>Indicator</p>

            <select className='input indicatorTableInput' value={indicator} onChange={e => handleInput(e.target.value, 'indicator')}>
                {tableType === "List" && (
                    <>
                        <option value="powerData">Geothermal power plants</option>
                        <option value="hcData">Geothermal H&C projects</option>
                        <option value="countries">Country list</option>
                    </>
                )}
                {tableType === "Report" && (
                    <>
                        <option value="powerDataReport">Geothermal power plants</option>
                        <option value="powerOperation">Geothermal power plants in operation</option>
                        <option value="hcProjects">Geothermal H&C projects</option>
                        <option value="powerTotal">Power total (capacity and production)</option>
                        <option value="hcTotal">H&C total (capacity and production)</option>
                    </>
                )}
            </select>

            <p className='orange smallText mediumFont inputTitle countryChartTitle'>Region / Country</p>
            <Select
                styles={customStyles}
                classNamePrefix="gang"
                options={options}
                isMulti name="countries"
                className='countryChartInput'
                defaultValue={country}
                onChange={value => { handleInput(value, 'country') }}
                components={{ ClearIndicator: () => null }}
            />
            <p className='orange smallText mediumFont inputTitle yearTableInput'> Year</p>
            <select className='input yearTableInput' value={year} onChange={e => handleInput(e.target.value, 'year')}>
                {yearsList && yearsList.map((year, index) => (
                    <option key={index} value={year}>
                        {year}
                    </option>
                ))}
            </select>
            <div id='export' className='input' onClick={toggleDropdown}>
                Export Table<span>↓</span>
            </div>
            {showDropdown && (
                <div className='dropdown'>
                    <button className='dropdown-item' onClick={() => { handleExportClickPDF(); setShowDropdown(false); }}>Export as PDF</button>
                    <button className='dropdown-item' onClick={() => { handleExportClickCSV(); setShowDropdown(false); }}>Export as CSV</button>
                </div>
            )}
        </>
    );
}